const defaultCompaniesState = () => {
  return {
    persistentFilter: {},
    persistentFilterQuery: '',
    persistentFilterQueryGroup: '',
    persistentFilterCompanyType: '',
    beforePathEnter: '',
    persistentFilterPartner: '',
  }
}
export default {
  namespaced: true,
  state: defaultCompaniesState(),
  mutations: {
    setPersistentFilter(state, persistentFilter) {
      Object.assign(state, { persistentFilter });
    },
    setPersistentFilterQuery(state, persistentFilterQuery) {
        Object.assign(state, { persistentFilterQuery });
    },
    setPersistentFilterQueryGroup(state, persistentFilterQueryGroup) {
      Object.assign(state, { persistentFilterQueryGroup });
    },
    setPersistentFilterCompanyType(state, persistentFilterCompanyType) {
        Object.assign(state, { persistentFilterCompanyType });
    },
    setBeforePathEnter(state, beforePathEnter) {
      Object.assign(state, { beforePathEnter });
    },
    setPersistentFilterPartner(state, persistentFilterPartner) {
      Object.assign(state, { persistentFilterPartner });
  },
  },
  actions: {}
}